<template>
	<van-tabbar v-model="active" class="fixbar">
		<van-tabbar-item icon="wap-home" :to="{ name: 'venue',params:{clubId:id} }">俱乐部</van-tabbar-item>
		<van-tabbar-item icon="completed" :to="{ name: 'class' }">课程表</van-tabbar-item>
		<!-- <van-tabbar-item icon="apps-o" :to="{ name: 'manage' }">场馆管理</van-tabbar-item> -->
		<van-tabbar-item icon="contact" @click="goTo()" :dot="dot">我的</van-tabbar-item>
	</van-tabbar>
</template>
<script>
import { Tabbar, TabbarItem } from 'vant';
export default {
	name: 'TheTabbar',
	components: {
		[Tabbar.name]: Tabbar,
		[TabbarItem.name]: TabbarItem
	},
	data(){
		return {
			active: 0, // 高亮索引
			dot: true,	// 红点
			id:sessionStorage.getItem("CLUBID"),   //俱乐部id
			role:''
		}
	},
	created() {
		// 根据当前路由高亮按钮
		switch (this.$router.history.current.name) {
			case 'manage':
			case 'managecoach':
			case 'my':
				this.active = 2;
				break;
			case 'class':
			case 'classdetail':
			case 'courseclassalone':
				this.active = 1;
				break;
			case 'courseclassmanage':
				this.active = -1;
				break;
			default:
				this.active = 0;
				break;
		}
	},
	beforeMount() {
    // 获取当前已登录用户信息
    this.$http.post('user/judgeLogin').then(res => {
      // console.log(res)
      if (res.data.code == 0) {
        this.user = res.data.value;
        if (this.user.roles.indexOf('ROLE_CLUB_ADMIN') !== -1) {
          // 俱乐部管理
          this.role = 'admin'
				}else if(this.user.roles.indexOf('ROLE_CLUB_CS') !== -1){
					// 客服
					this.role = 'clubcs'
				} else if(this.user.roles.indexOf('ROLE_COACH') !== -1){
					this.role = 'coach'
				} else {
          // 普通用户角色操作   if(this.user.roles.indexOf('ROLE_USER') !== -1)
          this.role = 'user'
        }
      }else{
        console.log('请登录')
      }
    });
	},
	methods:{
		goTo(){
			if(this.role == 'admin'){
				// 管理员 跳到 场馆管理页面  
				this.$router.push({path: '/manage?type=admin'})
			}else if(this.role == 'clubcs'){
				// 客服
				this.$router.push({path: '/manage?type=clubcs'})
			}else if(this.role == 'coach'){
				// 教练 
				this.$router.push({name: 'managecoach'})
			}else if(this.role == 'user'){
				//其他 跳到 个人主页
				location.href = `${location.origin}/training/#/my`
			}else{
				// 未登录 跳转 登录页
				location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
			}
		}
	}
}
</script>
<style lang="less">
	.fixbar{
		box-sizing: content-box;
	}
	.van-tabbar-item--active{
		color: #4b0!important;
	}
	@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
		.fixbar {
			padding-bottom: constant(safe-area-inset-bottom);
			padding-bottom: env(safe-area-inset-bottom);		
		}
		.main{ 
			padding-bottom: calc(60px+constant(safe-area-inset-bottom));
			padding-bottom: calc(60px+env(safe-area-inset-bottom));
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TheTabbar.vue